<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">海上航空運賃登録</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_OFS_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn @click="create" v-permit.SHARP_OFS_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length != 1"
          @click="edit"
          v-permit.SHARP_OFS_EDIT
          >{{ $t('app.buttons.edit') }}</v-btn
        >

        <v-btn
          :disabled="
            selected.length != 1 || selected[0].isFreightConfirm || isPartnerSa
          "
          @click="chargeGeneration"
          v-permit.SHARP_FD_CALCULATION
          >海上・航空運賃計算</v-btn
        >
        <v-btn
          :disabled="selected.length === 0 || isDapDdp"
          @click="exportInvoice"
          v-permit.SHARP_OFS_DOWNLOAD
          >フレイト I/V 出力</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field label="B/L NO" v-model="query.blNo"></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="D/O No" v-model="query.doNo" />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="INV. NO" v-model="query.invNo" />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="フレイトInvoice作成者"
                url="employees/kv"
                v-model="query.freightInvCreatorId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="海外取引先"
                url="companies/kv?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    label="B/L発行日"
                    v-model="query.blIssueDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    label="~"
                    v-model="query.blIssueDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-select
                label="輸送形態"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              ></remote-select>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="積出港"
                url="ports/kv"
                v-model="query.loadingPortCode"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="陸揚港"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.etdTo"
                    label="ETD"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :max="query.etaTo"
                    label="ETA"
                    v-model="query.etaFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.etaFrom"
                    label="~"
                    v-model="query.etaTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="本船名" v-model="query.shipName" />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.forwarder')"
                url="companies/forwarders/kv"
                v-model="query.forwarderId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-select clearable
                :items="isFreightConfirmStatusItems"
                label="ステータス"
                v-model="query.isFreightConfirm"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-1"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.blNo }}</td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.source === 'B1000' ? '新规' : 'FREIGHT' }}</td>
          <td>{{ props.item.blIssueDate }}</td>
          <td>{{ props.item.transportModeCode }}</td>
          <td>{{ props.item.loadingPortName }}</td>
          <td>{{ props.item.dischargePortName }}</td>
          <td>{{ props.item.etd }}</td>
          <td>{{ props.item.eta }}</td>
          <td>{{ props.item.shipName }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.forwarderName }}</td>
          <td>
            {{
              (props.item.valueCharge || props.item.branchValue)
                | currency({ fractionCount: 0 })
            }}
          </td>
          <td>
            {{ props.item.insuranceCharge | currency({ fractionCount: 0 }) }}
          </td>
          <td style="text-align: right">
            {{ props.item.totalFreight | currency({ fractionCount: 0 }) }}
          </td>
          <td>{{ props.item.freightConfirmDate }}</td>
          <td>{{ showFreightConfrimStatus(props.item) }}</td>
          <td>{{ props.item.freightInvCreatorName }}</td>
        </template>
      </v-data-table>
    </v-card>
    <document-dialog ref="docDlg" />
    <document-dialog-swt ref="docDlgSwt" />
  </v-container>
</template>

<script>
import DocumentDialog from '../B1001/DocumentDialog'
import DocumentDialogSwt from '../B1001/DocumentDialogSWT'

export default {
  components: {
    DocumentDialog,
    DocumentDialogSwt,
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  mounted() {
    this.$loadParams()
  },
  computed: {
    isPartnerSa() {
      return this.selected[0] && this.selected[0].shipmentType === 'PARTNERSA'
    },
    isDapDdp() {
      return (
        'INCOTERM-DAP,INCOTERM-DDP'.indexOf(this.selected[0].incotermId) !== -1
      )
    },
    isWarehouseTransport() {
      return (
        this.selected.length == 1 &&
        (this.isFCL || this.isAir) &&
        this.selected[0].isAllUnpaid &&
        this.selected[0].specialId &&
        this.selected[0].specialId.indexOf('WAREHOUSE_TRANSPORT') !== -1
      )
    },
    isFCL() {
      return (
        this.selected.length == 1 &&
        this.selected[0].stackTypeId &&
        this.selected[0].stackTypeId.indexOf('-FCL') !== -1
      )
    },
    isAir() {
      return (
        this.selected.length == 1 &&
        this.selected[0].transportModeCode &&
        this.selected[0].transportModeCode === 'AIR'
      )
    },
  },
  methods: {
    showFreightConfrimStatus(shipment) {
      return this.isFreightConfirmStatusItems.find(i=>i.value==(shipment.isFreightConfirm==null?false:shipment.isFreightConfirm)).text;
    },
    exportInvoice() {
      if (this.isWarehouseTransport && this.isFCL) {
        this.$refs.docDlgSwt.popup(this.selected)
      } else {
        this.$refs.docDlg.popup(this.selected)
      }
    },
    catch(res) {
      if (res.response.status === 500) {
        if (res.response.data.message == 'DO_HAS_CONFIRMED') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B1000.messages.errors.doHasConfirmed')
          )
        } else if (res.response.data.message == 'BL_NO_DUPLICATE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0400.messages.errors.invalidBlNo')
          )
        } else if (res.response.data.message == 'EXCHANGE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.exchangeRateNotFound')
          )
        } else if (
          res.response.data.message.indexOf('PRICING_NOT_FOUND') !== -1
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.pricingNotFound', {
              chargeItem: res.response.data.message.split(';')[1],
            })
          )
        } else if (res.response.data.message == 'INSURANCE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.insuranceRateNotFound')
          )
        } else if (res.response.data.message == 'TAX_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.taxRateNotFound')
          )
        } else if (res.response.data.message == 'COMMISSION_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.commissionRateNotFound')
          )
        } else {
          this.$message('', `system error, module:${this.$route.path}`)
        }
      }
    },
    chargeGeneration() {
      this.$http
        .put(
          `/shipping-advices/${this.selected[0].id}/calc?addFreightInvNo=true`
        )
        .then(() => {
          this.$router.push({
            path: '/B1001/edit',
            query: { id: this.selected[0].id },
          })
        })
        .catch(this.catch)
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/shipping-advices?view=B1000', this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    create() {
      localStorage.removeItem('sourceB1000Id')
      this.$router.push({
        name: 'B1001New',
      })
    },
    edit() {
      localStorage.removeItem('sourceB1000Id')
      this.$router.push({
        path: '/B1001/edit',
        query: { id: this.selected[0].id },
      })
    },
  },
  data() {
    return {
      isFreightConfirmStatusItems: [
        {
          text: 'フレイト確認済み',
          value: true,
        },
        {
          text: 'フレイト未確認',
          value: false,
        },
      ],
      headers: [
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: 'doNo', value: 'doNo', sortable: false },
        { text: '区分', value: 'category', sortable: false },
        { text: 'B/L発行日', value: 'blIssueDate', sortable: false },
        { text: '輸送形態', value: 'transportModeCode', sortable: false },
        { text: '積出港', value: 'loadingPortName', sortable: false },
        { text: '陸揚港', value: 'dischargePortName', sortable: false },
        { text: 'ETD', value: 'etd', sortable: false },
        { text: 'ETA', value: 'eta', sortable: false },
        { text: '本船名', value: 'shipName', sortable: false },
        { text: '海外取引先', value: 'partnerCode', sortable: false },
        { text: 'サプライヤー', value: 'forwarderCode', sortable: false },
        { text: '商品代金', value: 'valueCharge', sortable: false },
        { text: '保険費用', value: 'insuranceCharge', sortable: false },
        { text: 'フレイト合計金額', value: 'totalFreight', sortable: false },
        { text: 'フレイト確認日', value: 'lastCalDate', sortable: false },
        { text: 'ステータス', value: 'isFreightConfirmStatus', sortable: false },
        {
          text: 'フレイトInvoice作成者',
          value: 'freightInvCreatorName',
          sortable: false,
        },
      ],
      selected: [],
      query: {},
      results: [],
      pagination: {
        rowsPerPage: 10,
      },
      loading: false,
    }
  },
}
</script>
